// src/services/AuthService.js

import axios from 'axios';


import serveradresse_settings from '@/settings/serveradresse_settings.js';
const url = serveradresse_settings.config_server_adresse.url;


export default {


  async zeigewerftliste_per_id(id_sar) {
    return axios
      .post(url + 'zeigewerftliste_per_id/', id_sar)
      .then(response => response.data);
  },
 
  async zeige_auswahl_werftpunkt_bereiche() {
    return axios
      .post(url + 'zeige_auswahl_werftpunkt_bereiche/')
      .then(response => response.data);
  },
  
  async speichere_bereich_werft(credentials) {
    return axios
      .post(url + 'speichere_bereich_werft/', credentials)
      .then(response => response.data);
  },
  

  async speichere_werft_punkt_datum(credentials) {
    return axios
      .post(url + 'speichere_werft_punkt_datum/', credentials)
      .then(response => response.data);
  },
  
  async speichere_werft_punkt_beschreibung(credentials) {
    return axios
      .post(url + 'speichere_werft_punkt_beschreibung/', credentials)
      .then(response => response.data);
  },



  
  async zeigegruppenmodule_per_id(credentials) {
    return axios
      .post(url + 'zeigegruppenmodule_per_id/', credentials)
      .then(response => response.data);
  },


  async zeigeeinzelmodule_per_id(credentials) {
    return axios
      .post(url + 'zeigeeinzelmodule_per_id/', credentials)
      .then(response => response.data);
  },




  async neuen_werftpunkt_einfuegen(credentials) {
    return axios
      .post(url + 'neuen_werftpunkt_einfuegen/', credentials)
      .then(response => response.data);
  },

  
// 
//   async aufgabe_loeschen(credentials) {
//     return axios
//       .post(url + 'aufgabe_loeschen/', credentials)
//       .then(response => response.data);
//   },
// 
//  
//   async zeigeaufgaben(credentials) {
//     return axios
//       .post(url + 'zeigeaufgaben/', credentials)
//       .then(response => response.data);
//   },
// 
// 
//   async zeigeaufgaben_mit_auswahl(credentials) {
//     return axios
//       .post(url + 'zeigeaufgaben_mit_auswahl/', credentials)
//       .then(response => response.data);
//   },
// 
//   async zeigeaufgabe_per_id_zuordnung_final_gmv_sar(credentials) {
//     return axios
//       .post(url + 'zeigeaufgabe_per_id_zuordnung_final_gmv_sar/', credentials)
//       .then(response => response.data);
//   },
// 
//   async zeigeaufgabe_per_id_aufgabe(credentials) {
//     return axios
//       .post(url + 'zeigeaufgabe_per_id_aufgabe/', credentials)
//       .then(response => response.data);
//   },
//   
// 

  async update_aufgabe(credentials) {
    return axios
      .post(url + 'update_aufgabe/', credentials)
      .then(response => response.data);
  },

  async update_text_feld(credentials) {
    return axios
      .post(url + 'update_text_feld/', credentials)
      .then(response => response.data);
  },

  async update_checkbox_feld(credentials) {
    return axios
      .post(url + 'update_checkbox_feld/', credentials)
      .then(response => response.data);
  },

};